<template>
    <b-row class="no-gutters w-100">
        <b-col md="12" class="align-self-center px-3">
            <small>{{ model.provider }}</small>
            <br>
            <strong>{{ model.name }}</strong>
        </b-col>
        <b-col xs="6" class="align-self-center px-3">
            <span>ASIN:{{ model.data.asin }}</span>
            <br>
            <span>SKU:{{ model.data.sellerSku }}</span>
        </b-col>
        <b-col xs="6" class="align-self-center px-3 text-right">
            <b-form-checkbox v-model="model.synced" switch @change="onChange">
            </b-form-checkbox>
            <span>x{{ model.quantity }}</span>
        </b-col>
    </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        toggleSyncedSwitch: {
            type: [ Function, Boolean, ],
            required: false,
            default: true,
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
        onChange() {
            if (typeof this.toggleSyncedSwitch === 'function') {
                this.toggleSyncedSwitch(this.model)
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>

